import styled from "@emotion/styled";
import theme from "../../styles/theme";

export const TableBase = styled.div`
  color: ${theme.colors.darkBlues[75]};
  max-width: 844px;

  ${theme.largerThan.md} {
  }
`;

export const Heading = styled.h2`
  padding-bottom: 40px;
  text-align: center;
`;

export const Title = styled.div`
  font-size: 1rem;
  line-height: 1.25rem;
  margin-bottom: 4px;
`;

export const Caption = styled.div`
  margin-top: 12px;
  font-size: 13px;
  line-height: 21px;
`;

// Makes table scroll on mobile if there is overflow
export const TableWrapper = styled.div`
  max-height: 750px;
  overflow: auto;

  ${theme.largerThan.sm} {
    max-height: initial;
  }
`;

export const StyledTable = styled.table`
  border-collapse: collapse;
  width: 100%;
  font-size: 16px;
  line-height: 24px;
  table-layout: fixed;
`;

export const TableHead = styled.thead`
  border-bottom: 2px solid ${theme.colors.darkBlues[10]};
  text-align: left;
`;

export const TableHeader = styled.th`
  font-weight: 600;
  padding: 12px;
  background: #ffffff;

  /* Make table headers scroll with page if overflowed */
  position: sticky;
  top: 0;

  ${theme.largerThan.sm} {
    position: initial;
    top: initial;
  }

  ${theme.smallerThan.md} {
    display: none;
  }
`;

export const TableRow = styled.tr`
  margin-bottom: 10px;
  border-bottom: 1px solid ${theme.colors.darkBlues[10]};

  &:last-child {
    border-bottom: 2px solid ${theme.colors.darkBlues[10]};
  }

  ${theme.smallerThan.md} {
    &:nth-of-type(odd) {
      background: ${theme.colors.darkBlues[5]};
    }
  }
`;

export const TableBody = styled.tbody``;

export const TableEntry = styled.td`
  padding: 24px 12px;

  &:nth-of-type(even) {
    background: ${theme.colors.darkBlues[5]};
  }

  & img {
    width: 100%;
    object-fit: cover;

    ${theme.largerThan.sm} {
      max-height: 475px;
    }
  }
  ${theme.smallerThan.md} {
    display: flex;
    justify-content: space-between;
    background: transparent !important;
    &:last-child {
      border-bottom: 0;
    }
  }
`;

export const MobileHeader = styled.div`
  display: none;
  ${theme.smallerThan.md} {
    display: block;
    font-weight: bold;
    width: 50%;
  }
`;

export const EntryValue = styled.div`
  ${theme.smallerThan.md} {
    width: 50%;
  }
`;
